export const InputType ={EmailPhone :"emailPhone" , Email :"email" , Phone: "phone"}
export const Error = {
    InvalidPhoneNumber :"Please Enter Valid phone number",
    InvalidEmail : "please enter a valid email",
    InvalidInput : "please enter a valid input"
} 
export const ClassName= {
    CountryCode:"regulatory-updates__input-flag regulatory-updates__input-flag--",
    PhoneClass:"regulatory-updates__input-value real-time-val greyBackground regulatory-updates__country regulatory-updates__country--",
    EmailClass:"regulatory-updates__input-value real-time-val greyBackground"
}

// eslint-disable-next-line no-useless-escape
export const validateEmailRegex =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;